module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/philosophy01-700e7f894a41a51bea12fd48d613bd2b.png";